// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PythonTemplateSelect-module__dsAccented--xGmkN,.PythonTemplateSelect-module__dsAccented--xGmkN *{font-weight:500}.PythonTemplateSelect-module__dsDefaultWeight--PmuOD,.PythonTemplateSelect-module__dsDefaultWeight--PmuOD *{font-weight:400}h5.PythonTemplateSelect-module__dsAccented--xGmkN,h5.PythonTemplateSelect-module__dsAccented--xGmkN *{font-weight:700}.PythonTemplateSelect-module__dsUnderline--ED7Nq,.PythonTemplateSelect-module__dsUnderline--ED7Nq *{text-decoration:underline}.PythonTemplateSelect-module__dsAccented2--GgkoC,.PythonTemplateSelect-module__dsAccented2--GgkoC *{font-weight:700}.PythonTemplateSelect-module__dsBodyXL--NnOvP,.PythonTemplateSelect-module__dsBodyXL--NnOvP *{font-size:18px;line-height:27px}.PythonTemplateSelect-module__dsBodyLarge--LGHdU,.PythonTemplateSelect-module__dsBodyLarge--LGHdU *{font-size:16px;line-height:24px}.PythonTemplateSelect-module__dsBody--Rk9Bm,.PythonTemplateSelect-module__dsBody--Rk9Bm *{font-size:14px;line-height:20px}.PythonTemplateSelect-module__dsBodySmall--TKOpt,.PythonTemplateSelect-module__dsBodySmall--TKOpt *{font-size:12px;line-height:18px}.PythonTemplateSelect-module__dsBodyXS--c0mp2,.PythonTemplateSelect-module__dsBodyXS--c0mp2 *{font-size:10px;line-height:15px}.PythonTemplateSelect-module__dsActionLarge--gDaMZ,.PythonTemplateSelect-module__dsActionLarge--gDaMZ *{font-size:16px;line-height:18px}.PythonTemplateSelect-module__dsAction--piGYr,.PythonTemplateSelect-module__dsAction--piGYr *{font-size:14px;line-height:16px}.PythonTemplateSelect-module__dsActionSmall--ZqlGD,.PythonTemplateSelect-module__dsActionSmall--ZqlGD *{font-size:12px;line-height:14px}.PythonTemplateSelect-module__dsColumnHeadLine--PHem7,.PythonTemplateSelect-module__dsColumnHeadLine--PHem7 *{font-size:12px;line-height:18px;font-weight:500;text-transform:uppercase}.PythonTemplateSelect-module__dsLightXL--gY5MT,.PythonTemplateSelect-module__dsLightXL--gY5MT *{font-size:120px;line-height:160px;font-weight:300}.PythonTemplateSelect-module__dsLightLarge--IE3Zq,.PythonTemplateSelect-module__dsLightLarge--IE3Zq *{font-size:48px;line-height:64px;font-weight:300}.PythonTemplateSelect-module__dsLight--qohSa,.PythonTemplateSelect-module__dsLight--qohSa *{font-size:32px;line-height:64px;font-weight:300}.PythonTemplateSelect-module__dsLightSmall--nSqNw,.PythonTemplateSelect-module__dsLightSmall--nSqNw *{font-size:24px;line-height:36px;font-weight:300}.PythonTemplateSelect-module__dsLightXS--Q9gCJ,.PythonTemplateSelect-module__dsLightXS--Q9gCJ *{font-size:18px;line-height:27px;font-weight:300}.PythonTemplateSelect-module__templateBtnContainer--uq_73{display:block}.PythonTemplateSelect-module__templateBtnPrefix--we2U9{color:var(--gray-5);margin-right:4px}.PythonTemplateSelect-module__templateSelectorContainer--HjuAJ{background:var(--background-color);border:1px solid var(--gray-3);border-radius:4px;box-shadow:var(--shadow-2);margin-top:4px;min-width:280px;max-width:320px}.PythonTemplateSelect-module__templateItem--HshZy{display:flex;align-items:center;justify-content:space-between;padding:8px 12px;cursor:pointer}.PythonTemplateSelect-module__templateItem--HshZy:hover{background:var(--gray-1)}.PythonTemplateSelect-module__templateItem--HshZy.PythonTemplateSelect-module__selected--ZjA0o{background:var(--primary-color-light)}.PythonTemplateSelect-module__templateName--zSRXk{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.PythonTemplateSelect-module__formContainer--HmKNs{display:flex;flex-direction:column;gap:12px;width:340px}.PythonTemplateSelect-module__field--JZwus{display:flex;flex-direction:column;gap:10px}.PythonTemplateSelect-module__fieldLabel--C6wSq{color:#5f677e;font-size:14px}.PythonTemplateSelect-module__toggle--C9GFG{display:flex;gap:10px;align-items:center}.PythonTemplateSelect-module__toggle--C9GFG label{font-weight:normal}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dsPrimaryBlue": `#5155f5`,
	"dsSecondaryBlue": `#e5e5fe`,
	"dsHoverBlue": `#3438d0`,
	"dsClickBlue": `#262ab5`,
	"dsClickBlue2": `#d3d4f0`,
	"dsClickBlue3": `#a8a9e1`,
	"dsClickBlue4": `#7c7fd2`,
	"dsClickBlue5": `#5154c3`,
	"dsBlack": `#191a1c`,
	"dsGray1": `#f5f7fa`,
	"dsGray2": `#eaecf2`,
	"dsGray3": `#dce0ea`,
	"dsGray4": `#b3b9c8`,
	"dsGray5": `#8c95a8`,
	"dsGray6": `#5f677e`,
	"dsGray7": `#3d4355`,
	"dsGrayMainHeader": `#373d4d`,
	"dsGrayLine": `#e2e2e2`,
	"dsGrayBackground": `#f4f4f5`,
	"dsWhite": `#fff`,
	"dsWarning": `#f14668`,
	"dsSuccess": `#00d41f`,
	"dsActionYellow": `#f3b32a`,
	"dsActionYellowLight": `#fef7e7`,
	"dsChartGreen": `#19a979`,
	"dsChartPink": `#ed4a7b`,
	"dsChartYellow": `#f4b400`,
	"dsChartPurple": `#945fcf`,
	"dsChartTurquoise": `#12a4b4`,
	"dsChartBlue": `#525df4`,
	"dsChartOrange": `#fb9341`,
	"dsChartBurgundy": `#bf399e`,
	"dsChartRed": `#ef6868`,
	"dsChartGrey": `#6c8893`,
	"dsChartDarkBlue": `#2e6497`,
	"dsChartOrangeLight": `#feddc3`,
	"dsChartLightBlue": `#5899da`,
	"dsTeamProRed": `#ff594c`,
	"dsFreeYellow": `#ffb42e`,
	"dsTeamsGreen": `#52aea4`,
	"dsTableRowHover": `#f7f8fa`,
	"dsTableNegativeHighlight": `#ffeae9`,
	"dsTableNegativeHighlightHover": `#ffe0df`,
	"dsSparklinePurple": `#777af7`,
	"dsPrimaryBlue100": `#f3f4fe`,
	"dsPrimaryBlue200": `#cfd0ff`,
	"dsPrimaryBlue300": `#8889f8`,
	"dsPrimaryBlue400": `#6c6ff7`,
	"dsPrimaryBlue500": `#575af5`,
	"dsPrimaryBlue600": `#4449f3`,
	"dsPrimaryBlue700": `#3339f1`,
	"dsPrimaryBlue800": `#1f29ef`,
	"dsPrimaryBlue900": `#1823de`,
	"dsPrimaryBlue1000": `#151fcc`,
	"dsMainHeader100": `#f9f9fa`,
	"dsMainHeader200": `#b5b7bc`,
	"dsMainHeader300": `#91959d`,
	"dsMainHeader400": `#7b7f89`,
	"dsMainHeader500": `#6b6f7b`,
	"dsMainHeader600": `#5e6370`,
	"dsMainHeader700": `#545967`,
	"dsMainHeader800": `#4b505f`,
	"dsMainHeader900": `#434958`,
	"dsMainHeader1000": `#3d4252`,
	"dsWarning100": `#fcdce3`,
	"dsWarning200": `#f9b5c2`,
	"dsWarning300": `#f46d88`,
	"dsWarning400": `#e44262`,
	"dsWarning500": `#c83a56`,
	"dsWarning600": `#b2344d`,
	"dsWarning700": `#a02f45`,
	"dsWarning800": `#922a3f`,
	"dsWarning900": `#852639`,
	"dsWarning1000": `#792334`,
	"dsH1FontSize": `32px`,
	"dsH1LineHeight": `48px`,
	"dsH2FontSize": `26px`,
	"dsH2LineHeight": `39px`,
	"dsH3FontSize": `22px`,
	"dsH3LineHeight": `33px`,
	"dsH4FontSize": `18px`,
	"dsH4LineHeight": `27px`,
	"dsH5FontSize": `16px`,
	"dsH5LineHeight": `24px`,
	"dsH6FontSize": `14px`,
	"dsH6LineHeight": `20px`,
	"dsBodyXLFontSize": `18px`,
	"dsBodyXLLineHeight": `27px`,
	"dsBodyLargeFontSize": `16px`,
	"dsBodyLargeLineHeight": `24px`,
	"dsBodyFontSize": `14px`,
	"dsBodyLineHeight": `20px`,
	"dsBodySmallFontSize": `12px`,
	"dsBodySmallLineHeight": `18px`,
	"dsBodyXSFontSize": `10px`,
	"dsBodyXSLineHeight": `15px`,
	"dsActionLargeSize": `16px`,
	"dsActionLargeLineHeight": `18px`,
	"dsActionSize": `14px`,
	"dsActionLineHeight": `16px`,
	"dsActionSmallSize": `12px`,
	"dsActionSmallLineHeight": `14px`,
	"dsColumnHeadFontSize": `12px`,
	"dsColumnHeadLineHeight": `18px`,
	"dsLightXLFontSize": `120px`,
	"dsLightXLLineHeight": `160px`,
	"dsLightLargeFontSize": `48px`,
	"dsLightLargeLineHeight": `64px`,
	"dsLightFontSize": `32px`,
	"dsLightLineHeight": `64px`,
	"dsLightSmallFontSize": `24px`,
	"dsLightSmallLineHeight": `36px`,
	"dsLightXSFontSize": `18px`,
	"dsLightXSLineHeight": `27px`,
	"dsXsIconSize": `12px`,
	"dsSmallIconSize": `14px`,
	"dsMediumIconSize": `16px`,
	"dsMediumFieldHeight": `36px`,
	"dsSmallFieldHeight": `32px`,
	"dsLargeFieldHeight": `40px`,
	"dsFieldHorizontalPadding": `12px`,
	"dsAccented": `PythonTemplateSelect-module__dsAccented--xGmkN`,
	"dsDefaultWeight": `PythonTemplateSelect-module__dsDefaultWeight--PmuOD`,
	"dsUnderline": `PythonTemplateSelect-module__dsUnderline--ED7Nq`,
	"dsAccented2": `PythonTemplateSelect-module__dsAccented2--GgkoC`,
	"dsBodyXL": `PythonTemplateSelect-module__dsBodyXL--NnOvP`,
	"dsBodyLarge": `PythonTemplateSelect-module__dsBodyLarge--LGHdU`,
	"dsBody": `PythonTemplateSelect-module__dsBody--Rk9Bm`,
	"dsBodySmall": `PythonTemplateSelect-module__dsBodySmall--TKOpt`,
	"dsBodyXS": `PythonTemplateSelect-module__dsBodyXS--c0mp2`,
	"dsActionLarge": `PythonTemplateSelect-module__dsActionLarge--gDaMZ`,
	"dsAction": `PythonTemplateSelect-module__dsAction--piGYr`,
	"dsActionSmall": `PythonTemplateSelect-module__dsActionSmall--ZqlGD`,
	"dsColumnHeadLine": `PythonTemplateSelect-module__dsColumnHeadLine--PHem7`,
	"dsLightXL": `PythonTemplateSelect-module__dsLightXL--gY5MT`,
	"dsLightLarge": `PythonTemplateSelect-module__dsLightLarge--IE3Zq`,
	"dsLight": `PythonTemplateSelect-module__dsLight--qohSa`,
	"dsLightSmall": `PythonTemplateSelect-module__dsLightSmall--nSqNw`,
	"dsLightXS": `PythonTemplateSelect-module__dsLightXS--Q9gCJ`,
	"templateBtnContainer": `PythonTemplateSelect-module__templateBtnContainer--uq_73`,
	"templateBtnPrefix": `PythonTemplateSelect-module__templateBtnPrefix--we2U9`,
	"templateSelectorContainer": `PythonTemplateSelect-module__templateSelectorContainer--HjuAJ`,
	"templateItem": `PythonTemplateSelect-module__templateItem--HshZy`,
	"selected": `PythonTemplateSelect-module__selected--ZjA0o`,
	"templateName": `PythonTemplateSelect-module__templateName--zSRXk`,
	"formContainer": `PythonTemplateSelect-module__formContainer--HmKNs`,
	"field": `PythonTemplateSelect-module__field--JZwus`,
	"fieldLabel": `PythonTemplateSelect-module__fieldLabel--C6wSq`,
	"toggle": `PythonTemplateSelect-module__toggle--C9GFG`
};
module.exports = ___CSS_LOADER_EXPORT___;
